import React, { useState, useEffect } from "react";
import ModalB from "react-bootstrap/Modal";
import "../../components/modal/modal.css";
import InputTextPatrocinador from "../../pages/cadastro/inputtextPatrocinador";
import InputRadio from "../../pages/cadastro/inputradio";

import { toast } from "react-toastify";

const ModalAdmPatrociandor = (props) => {
  const [nome, setNomeCompleto] = useState("");
  const [cargo, setCargo] = useState("");
  const [nome_cracha, setNomeCracha] = useState("");
  const [email, setEmail] = useState("");
  const [dt_nascimento, setDataNascimento] = useState("");
  const [celular, setCelular] = useState("");
  const [telefone_comercial, setTelComercial] = useState("");
  const [cpf, setCPF] = useState("");
  const [sexo, setSexo] = useState("");

  // Estados para validação
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const [tituloModal, setTituloModal] = useState(props.titulo);

  const notifyError = (mensagem) => toast.error(mensagem, { theme: "colored" });

  useEffect(() => {
    // Se estamos no modo de edição e temos dados do participante
    if (props.modoEdicao && props.participanteParaEditar) {
      const participante = props.participanteParaEditar;
      console.log(participante);
      setNomeCompleto(participante.nome || "");
      setCargo(participante.cargo || "");
      setNomeCracha(participante.nome_cracha || "");
      setEmail(participante.email || "");
      setDataNascimento(participante.dt_nascimento.split("T")[0] || "");
      setCelular(participante.celular || "");
      setTelComercial(participante.telefone_comercial || "");
      setCPF(participante.cpf || "");
      let sexo = participante.sexo === "masculino" ? "Masculino" : "Feminino";
      setSexo(sexo || "");
    }
  }, [props.modoEdicao, props.participanteParaEditar]);

  const handleModal = () => props.toggleModal();

  // Função de validação de campos
  const validateField = (field, value) => {
    if (!value || value.trim() === "") {
      return "Este campo é obrigatório";
    }

    switch (field) {
      case "email":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return "Email inválido. Exemplo: usuario@empresa.com";
        }
        break;

      case "cpf":
        const cpfNumbers = value.replace(/\D/g, '');
        if (cpfNumbers.length !== 11) {
          return "CPF deve ter 11 dígitos";
        }
        break;

      case "celular":
      case "telefone_comercial":
        const phoneNumbers = value.replace(/\D/g, '');
        if (phoneNumbers.length < 10 || phoneNumbers.length > 11) {
          return "Telefone deve ter 10 ou 11 dígitos";
        }
        break;

      case "dt_nascimento":
        const hoje = new Date();
        const nascimento = new Date(value);
        const idade = hoje.getFullYear() - nascimento.getFullYear();
        if (idade < 16 || idade > 120) {
          return "Data de nascimento inválida";
        }
        break;

      case "nome":
        if (value.trim().split(' ').length < 2) {
          return "Digite o nome completo";
        }
        break;

      case "nome_cracha":
        if (value.trim().length < 3) {
          return "Nome para crachá deve ter pelo menos 3 caracteres";
        }
        break;
    }

    return null;
  };

  // Handler para validação no blur
  const handleFieldBlur = (field, value) => {
    // Marcar campo como tocado
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));

    // Executar validação
    const error = validateField(field, value);
    setErrors(prev => ({
      ...prev,
      [field]: error
    }));
  };

  // Função para verificar se o formulário está válido
  const isFormValid = () => {
    const requiredFields = ['nome', 'nome_cracha', 'email', 'cpf', 'dt_nascimento', 'celular', 'cargo', 'telefone_comercial', 'sexo'];
    
    return requiredFields.every(field => {
      const value = getFieldValue(field);
      return value && value.trim() !== "" && !errors[field];
    });
  };

  // Função para obter valor do campo
  const getFieldValue = (field) => {
    switch (field) {
      case 'nome': return nome;
      case 'nome_cracha': return nome_cracha;
      case 'email': return email;
      case 'cpf': return cpf;
      case 'dt_nascimento': return dt_nascimento;
      case 'celular': return celular;
      case 'cargo': return cargo;
      case 'telefone_comercial': return telefone_comercial;
      case 'sexo': return sexo;
      default: return '';
    }
  };

  const handleInclusao = () => {
    // Validar todos os campos antes de incluir
    const allFields = ['nome', 'nome_cracha', 'email', 'cpf', 'dt_nascimento', 'celular', 'cargo', 'telefone_comercial', 'sexo'];
    
    const newErrors = {};
    allFields.forEach(field => {
      const value = getFieldValue(field);
      const error = validateField(field, value);
      if (error) {
        newErrors[field] = error;
      }
    });

    setErrors(newErrors);

    // Se há erros, não prosseguir
    if (Object.keys(newErrors).length > 0) {
      notifyError("Por favor, corrija os erros no formulário");
      return;
    }

    let participante = {
      nome,
      cargo,
      nome_cracha,
      email,
      dt_nascimento,
      celular,
      telefone_comercial,
      cpf,
      sexo,
      tipo: "participante_patrocinador",
    };

    // Se estamos no modo de edição, incluir o ID do participante
    if (props.modoEdicao && props.participanteParaEditar) {
      participante.id = props.participanteParaEditar.id;
      participante.tipo = props.participanteParaEditar.tipo;
    }

    props.incluirParticipante(participante);
    limparFormulario();
    handleModal();
  };

  const limparFormulario = () => {
    setNomeCompleto("");
    setCargo("");
    setNomeCracha("");
    setEmail("");
    setDataNascimento("");
    setCelular("");
    setTelComercial("");
    setCPF("");
    setSexo("");
    setErrors({});
    setTouched({});
  };

  return (
    <>
      <ModalB show={props.show} onHide={handleModal}>
        <ModalB.Header closeButton>
          <ModalB.Title className="titulo-modal">{tituloModal}</ModalB.Title>
        </ModalB.Header>
        <ModalB.Body>
          <div className="area-modal-reuniao">
            <div className="area-inputs-modal">
              <div className="row g-3">
                <div className="col-6">
                  <InputTextPatrocinador
                    label="Nome completo"
                    type="text"
                    requered={true}
                    value={nome}
                    onChange={setNomeCompleto}
                    onBlur={(value) => handleFieldBlur("nome", value)}
                    error={touched.nome ? errors.nome : null}
                    focus={true}
                  />
                </div>
                <div className="col-6">
                  <InputTextPatrocinador
                    label="Nome para o crachá"
                    type="text"
                    requered={true}
                    value={nome_cracha}
                    onChange={setNomeCracha}
                    onBlur={(value) => handleFieldBlur("nome_cracha", value)}
                    error={touched.nome_cracha ? errors.nome_cracha : null}
                  />
                </div>
                <div className="col-6">
                  <InputTextPatrocinador
                    label="E-mail"
                    type="email"
                    requered={true}
                    value={email}
                    onChange={setEmail}
                    onBlur={(value) => handleFieldBlur("email", value)}
                    error={touched.email ? errors.email : null}
                  />
                </div>
                <div className="col-6">
                  <InputTextPatrocinador
                    label="CPF"
                    type="text"
                    requered={true}
                    value={cpf}
                    onChange={setCPF}
                    onBlur={(value) => handleFieldBlur("cpf", value)}
                    error={touched.cpf ? errors.cpf : null}
                    mascara="999.999.999-99"
                    countCPF={true}
                  />
                </div>
                <div className="col-6">
                  <InputTextPatrocinador
                    label="Data de nascimento"
                    type="date"
                    requered={true}
                    value={dt_nascimento}
                    onChange={setDataNascimento}
                    onBlur={(value) =>
                      handleFieldBlur("dt_nascimento", value)
                    }
                    error={
                      touched.dt_nascimento ? errors.dt_nascimento : null
                    }
                  />
                </div>
                <div className="col-6">
                  <InputRadio
                    label="Sexo"
                    values={["Masculino", "Feminino"]}
                    onChange={setSexo}
                    value={sexo}
                  />
                </div>
                <div className="col-6">
                  <InputTextPatrocinador
                    label="Telefone comercial"
                    type="text"
                    requered={true}
                    value={telefone_comercial}
                    onChange={setTelComercial}
                    onBlur={(value) =>
                      handleFieldBlur("telefone_comercial", value)
                    }
                    error={
                      touched.telefone_comercial
                        ? errors.telefone_comercial
                        : null
                    }
                    mascara="(99) 99999-9999"
                  />
                </div>
                <div className="col-6">
                  <InputTextPatrocinador
                    label="Celular"
                    type="text"
                    requered={true}
                    value={celular}
                    onChange={setCelular}
                    onBlur={(value) => handleFieldBlur("celular", value)}
                    error={touched.celular ? errors.celular : null}
                    mascara="(99) 99999-9999"
                  />
                </div>
                <div className="col-6">
                  <InputTextPatrocinador
                    label="Cargo"
                    type="text"
                    requered={true}
                    value={cargo}
                    onChange={setCargo}
                    onBlur={(value) => handleFieldBlur("cargo", value)}
                    error={touched.cargo ? errors.cargo : null}
                  />
                </div>
              </div>
            </div>
          </div>
        </ModalB.Body>
        {props.footer ? (
          <ModalB.Footer>
            <button
              style={{ backgroundColor: "#008A38" }}
              type="button"
              className="text-white btn botoes-cadastro"
              onClick={() => {
                handleInclusao();
              }}
              disabled={!isFormValid()}
            >
              {props.modoEdicao ? "Atualizar" : "Incluir"}
            </button>
          </ModalB.Footer>
        ) : (
          false
        )}
      </ModalB>
    </>
  );
};
export default ModalAdmPatrociandor;

